import React, {useEffect, useState} from 'react';
import LazyRangePicker from '../../cmp/lazy/LazyRangePicker';
import dayjs from 'dayjs';
import {get} from '../../../api';
import TopBrowsers from './components/TopBrowsers';
import TopLandingPage from './components/TopLandingPage';
import TopSourcePages from './components/TopSourcePages';
import AggregateDataRow from './components/AggregateDataRow';
import VisitsAnalysis from './components/VisitsAnalysis';
import Spinner from '../../cmp/Spinner';
import {FormattedMessage} from 'react-intl';

function Analytics() {
    const [dates, setDates] = useState([
        dayjs().subtract(1, 'month').startOf('day').toDate(),
        dayjs().endOf('day').toDate(),
    ])
    const [visits, setVisits] = useState([])
    const [sales, setSales] = useState(null)
    const [loading, setLoading] = useState(false)
    useEffect(()=>{
        setLoading(true)
        get('/analytics/visits', {
            startTime: dates[0],
            endTime: dates[1],
            startDate: dayjs(dates[0]).format('YYYY-MM-DD'),
            endDate: dayjs(dates[1]).format('YYYY-MM-DD')
        }).then((data) => {
            setLoading(false)
            setVisits(data.visits)
            setSales(data.sales)
            setLoading(false)
        }).catch((e) => {
            setLoading(false)
        })
    },[dates])
    return (
        <>
            <div className="row">
                <div className="col-md-8">
                    <h2><FormattedMessage id={"Analytics"}/></h2>
                </div>
                <div className="col-md-4">
                    <LazyRangePicker onChange={setDates} endDate={dates[1]}
                                     startDate={dates[0]}/>
                </div>
            </div>
            {
              loading ? <div className="text-center p-4">
                    <p><FormattedMessage id={"Loading Data...It might take a while"}/></p>
                    <Spinner size={'lg'}/>
                </div> : <>
                    <div className="card-group">
                        <TopBrowsers visits={visits || []}/>
                    </div>
                    <div className="card-group my-4">
                        <TopLandingPage visits={visits || []}/>
                        <TopSourcePages visits={visits || []}/>
                    </div>
                    <div className="card-group">
                        <AggregateDataRow sales={sales} visits={visits || []}/>
                    </div>
                    <div className="my-4">
                        <VisitsAnalysis visits={visits || []}/>
                    </div>
                </>
            }
        </>
    );
}

export default Analytics;
